export function removeByRegex(contentPattern, value) {
  return keepOnlyRegex(value, new RegExp('^' + contentPattern + '$'));
}

function keepOnlyRegex(value, regex, currentChar = 0) {
  // If current char is the last char.
  if (value == null || value === 'undefined' || value.toString().length == currentChar) {
    // Returns the given value.
    return value;
  }
  // If current char is not the last char.

  // Gets the value to test for validity.
  const testValue =
    value.toString().substring(0, currentChar) + value.toString().substring(currentChar, currentChar + 1);
  // If the value is valid.
  if (regex.test(testValue)) {
    // Moves to the next char validation.
    return keepOnlyRegex(value, regex, currentChar + 1);
  }
  // If the value is not valid.

  // Removes the current char.
  const newValue = value.toString().substring(0, currentChar) + value.toString().substring(currentChar + 1);
  // Checks for validity without the invalid value.
  return keepOnlyRegex(newValue, regex, currentChar);
}

export function formatPhoneNumber(number) {
  const formattedNumber = number?.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');

  const areaCode = formattedNumber?.match(/\((\d{2})\)/)[1];
  const firstTwo = formattedNumber?.slice(formattedNumber.indexOf(')') + 2, formattedNumber.indexOf(')') + 4);
  const lastTwo = formattedNumber?.slice(-2);

  const masked = `(${areaCode}) ${firstTwo}***-**${lastTwo}`;

  return masked;
}

export function formatEmail(email) {
  const [username, domain] = email.split('@');
  const maskedUsername = `${username.slice(0, 3)}${'*'.repeat(Math.max(username.length - 3, 0))}`;
  const domainParts = domain.split('.');
  const maskedDomain = `${'*'.repeat(Math.max(domainParts[0].length - 2, 0))}${domainParts[0].slice(-2)}.${domainParts
    .slice(1)
    .join('.')}`;

  return `${maskedUsername}@${maskedDomain}`;
}

export function hideEmailPartially(email) {
  if (email) {
    const maskedEmail = email.replace(/([^@.])/g, '*').split('');
    let previous = '';

    for (let i = 0; i < maskedEmail.length; i++) {
      if (
        i <= 2 ||
        previous === '.' ||
        previous === '@' ||
        i >= maskedEmail.length - 2 ||
        maskedEmail[i + 2] === '@' ||
        maskedEmail[i + 1] === '@'
      ) {
        maskedEmail[i] = email[i];
      }
      previous = email[i];
    }
    return maskedEmail.join('');
  }
  return '';
}

export function addBankMask(bankAccount) {
  bankAccount = keepOnlyRegex(bankAccount, new RegExp('^[0-9a-zA-Z]{0,11}$'));
  if (bankAccount.length >= 5) {
    return bankAccount.slice(0, bankAccount.length - 1) + '-' + bankAccount[bankAccount.length - 1];
  }
  return bankAccount;
}

export function getAddressFromGoogleGeocode(geocode) {
  const addressComponents = geocode.data[0].results[0].address_components;
  const address = {};
  addressComponents.forEach((component) => {
    if (component?.types.includes('postal_code')) {
      address.zipcode = {
        longName: component?.long_name,
        shortName: component?.short_name,
      };
    } else if (component?.types.includes('route')) {
      address.street = {
        longName: component?.long_name,
        shortName: component?.short_name,
      };
    } else if (component?.types.includes('sublocality')) {
      address.neighborhood = {
        longName: component?.long_name,
        shortName: component?.short_name,
      };
    } else if (component?.types.includes('administrative_area_level_2')) {
      address.city = {
        longName: component?.long_name,
        shortName: component?.short_name,
      };
    } else if (component?.types.includes('administrative_area_level_1')) {
      address.state = {
        longName: component?.long_name,
        shortName: component?.short_name,
      };
    } else if (component?.types.includes('country')) {
      address.country = {
        longName: component?.long_name,
        shortName: component?.short_name,
      };
    }
  });

  return address;
}

export function getPrice(value) {
  return value ? `R$ ${value.toFixed(2).toString().replace('.', ',')}` : 'R$ --';
}

export function formatTaxId(value) {
  if (value) {
    const digits = value.replace(/[^0-9]/g, '');
    if (digits.length === 11) {
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    }
  }

  return '';
}

export function formatTimer(time) {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}
